import { ContenidoDePagos } from 'src/app/pago/models/ContenidoDePagos.model';

export interface ContenidoState {
  contenido?: ContenidoDePagos;
}

export const getInitialContenidoState = (): ContenidoState => {
  return {};
};
